import { Panel, Typography } from '@components';
import { NetworkAdapterInterface } from '@interfaces';
import { ListComponent } from '@utils';
import React from 'react';
import { ArrowRight, Wifi } from 'react-feather';
import { CgEthernet } from 'react-icons/cg';

interface NetworkInformationProps {
  publicIp: string;
  interfaces: NetworkAdapterInterface[];
}

const iconsize = 28;

const adapterIcon = (type?: string) => {
  const lowerType = type?.toLowerCase() ?? '';

  if (lowerType.includes('ethernet')) {
    return <CgEthernet size={iconsize} />;
  }

  if (lowerType.includes('wireless')) {
    return <Wifi size={iconsize} />;
  }

  return null;
};

const split = (str: string, separator: string) => {
  const parts = str.split(separator);
  return str.split(separator).join('\n');
};

export const NetworkInformation = ({
  publicIp,
  interfaces,
}: NetworkInformationProps) => {
  return (
    <>
      <div className="mt-4 mb-6">
        <Typography tag="p" type="default">
          Publiek IP-adres
        </Typography>
        <Typography tag="p" type="subtitle">
          {publicIp}
        </Typography>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <ListComponent
          data={interfaces}
          renderItem={(adapter) =>
            adapter.defaultGateway !== '0.0.0.0' && (
              <Panel
                background="transparent"
                bordered
                classNames={
                  adapter.status?.toLowerCase() === 'up'
                    ? 'border-green-300'
                    : 'border-red-300'
                }
              >
                <div className="flex items-start gap-4 p-4">
                  <div className="flex-shrink-0 mt-1">
                    {adapterIcon(adapter.interfaceType)}
                  </div>

                  <div className="flex flex-col gap-1">
                    <Typography tag="p" type="default">
                      {adapter.interfaceName}
                    </Typography>

                    <div className="grid grid-cols-3 items-center">
                      <Typography tag="p" type="small">
                        {adapter.ipAddress[0]}
                      </Typography>

                      <div className="flex justify-center">
                        <ArrowRight size={12} />
                      </div>

                      <Typography tag="p" type="small" addClass="text-right">
                        {split(adapter.defaultGateway, ';')}
                      </Typography>
                    </div>

                    <Typography tag="p" type="small">
                      DNS: {split(adapter.dnsServers, ';')}
                    </Typography>

                    <Typography tag="p" type="small">
                      {adapter.linkSpeed / 1e6} Mbps
                    </Typography>
                  </div>
                </div>
              </Panel>
            )
          }
        />
      </div>
    </>
  );
};

export default NetworkInformation;
